<script setup lang="ts">
import { useToast } from '@/components/ui/toast/use-toast'
import Button from '@/components/ui/button/index.vue'

const props = defineProps<{
	sessions: App.Data.User.UserSessionData[]
}>()

const { toast } = useToast()

const dialogOpen = ref<boolean>(false)
const form = useForm({
	method: 'DELETE',
	url: route('user-sessions.destroy'),
	fields: {
		password: '',
	},
	hooks: {
		success: () => {
			dialogOpen.value = false

			toast({
				title: t('app.user_sessions_destroyed_successfully'),
				variant: 'successful',
			})
		},
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<user-submenu />

		<ui-alert variant="informative">
			{{ t('views.users.sessions.notice') }}
		</ui-alert>

		<div class="mt-3 flex flex-col gap-3">
			<div v-for="(session, i) in props.sessions" :key="i" class="bg-sidebar flex max-w-xl items-center gap-3 rounded p-2">
				<div>
					<i-ph-desktop-duotone v-if="session.is_desktop" class="text-primary size-8" />
					<i-ph-device-mobile-speaker-duotone v-else class="text-primary size-8" />
				</div>
				<div class="text-sm">
					<div class="text-muted-foreground">
						<div>{{ session.platform ?? t('app.unknown') }} - {{ session.browser ?? t('app.unknown') }} - {{ session.ip_address ?? t('app.unknown') }}</div>
						<div v-if="session.is_current_device" class="text-successful">
							{{ t('app.current_device') }}
						</div>
						<div v-else>
							{{ t('app.last_active') }} {{ session.last_active }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<ui-separator class="mt-3" />

		<ui-dialog v-model:open="dialogOpen">
			<ui-dialog-trigger :as="Button" variant="destructive" class="mt-3">
				{{ t('views.users.sessions.logout_other_sessions') }}
			</ui-dialog-trigger>

			<ui-dialog-content>
				<ui-dialog-header>
					<ui-dialog-title>
						{{ t('views.users.sessions.logout_other_sessions') }}
					</ui-dialog-title>
				</ui-dialog-header>

				<ui-dialog-description>
					<ui-form @submit.prevent="form.submit">
						<ui-form-item>
							<ui-label for="password">
								{{ t('validation.attributes.password') }}
							</ui-label>
							<ui-input
								id="password"
								v-model="form.fields.password"
								required
								type="password"
							/>
							<ui-form-error :message="form.errors.password" />
						</ui-form-item>

						<ui-button type="submit" :loading="form.processing" variant="destructive">
							{{ t('views.users.sessions.logout_other_sessions') }}
							<template #icon>
								<i-ph-arrow-right />
							</template>
						</ui-button>
					</ui-form>
				</ui-dialog-description>

				<ui-dialog-close
					class="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none"
				>
					<i-ph-x-bold class="size-4" />
				</ui-dialog-close>
			</ui-dialog-content>
		</ui-dialog>
	</content-wrapper>
</template>
